import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/dragon-tiles/$siteId/connectors")({
  component: RouteComponent,
});

function RouteComponent() {
  // Grid lives in the index route; the connector tile is a full-page child.
  return <Outlet />;
}
